import React, { useContext } from 'react';
import { StyleSheet, TouchableHighlight, View } from 'react-native';
import DyteClient from '@dytesdk/web-core';
import DyteText from './DyteText';
import { defaultIconPack, IconPack } from '../lib/icons';
import { DyteI18n, useLanguage } from '../lib/lang';
import { SvgXml } from 'react-native-svg';
import { useDyteSelector } from '@dytesdk/react-native-core';
import { DyteUIContext } from '../lib/context-provider/ui-context';

export default function ({
  meeting,
  iconPack = defaultIconPack,
  t,
}: {
  meeting: DyteClient;
  iconPack?: IconPack;
  t: DyteI18n;
}) {
  const defaultLang = useLanguage();
  t = t ?? defaultLang;
  iconPack = iconPack ?? defaultIconPack;
  const { storeStates, setStates } = useContext(DyteUIContext);
  const { colors } = storeStates.designSystem;
  const livestream = useDyteSelector((m) => m.livestream);
  const viewerCount = livestream?.viewerCount;
  const styles = StyleSheet.create({
    wrapper: {
      flexDirection: 'row',
      alignItems: 'center',
      padding: 4,
    },
    container: {
      flexDirection: 'row',
      borderRadius: 4,
      alignItems: 'center',
      justifyContent: 'center',
    },
    peopleIcon: {
      padding: 4,
      paddingLeft: 8,
    },
    text: {
      color: colors.textOnBrand,
      // paddingRight: 8,
    },
  });
  if (meeting.meta.viewType !== 'LIVESTREAM') return null;
  return (
    <TouchableHighlight
      underlayColor={colors.background[800]}
      style={styles.wrapper}
      onPress={() => {
        if (
          meeting.livestream &&
          meeting.meta.viewType === 'LIVESTREAM' &&
          meeting.self.permissions.acceptStageRequests
        ) {
          if (meeting.stage.status === 'ON_STAGE')
            setStates({
              ...storeStates,
              activeSidebar: true,
              activeMoreMenu: false,
              sidebar: 'participants',
            });
        }
      }}
    >
      <View style={styles.container}>
        <SvgXml
          xml={iconPack.viewers.replace('currentColor', colors.text)}
          width={25}
          height={25}
        />
        <DyteText style={styles.text}>
          {viewerCount} {t('viewers')}
        </DyteText>
      </View>
    </TouchableHighlight>
  );
}
